import { useMutation, useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useLocalStorage } from 'react-use';
import { ApiClient } from '../../../api/ApiClient';
import { v2 } from '../../../api/ApiInterfaceV2';
import { JiraProjectData } from '../../../api/endpoints/jira';
import { useResolve } from '../../Container';

export const useJiraIssueCreateSchemaQuery = (jiraProjectId: string, jiraIssueTypeId: string) => {

    const api = useResolve(ApiClient);

    return useQuery({
        queryKey: ['jira.issues.createSchema', jiraProjectId, jiraIssueTypeId],
        queryFn() {
            return api.exec(v2.jira.issues.createSchema({ jiraProjectId, jiraIssueTypeId }));
        },
        keepPreviousData: true,
    });
};

export const useCreateJiraIssueMutation = (jiraProjectId: string) => {

    const api = useResolve(ApiClient);

    return useMutation({
        async mutationFn(items: any[]) {
            return await api.exec(v2.jira.issues.create(
                items.map(x => ({
                    jiraProjectId,
                    ...x
                }))
            ));
        }
    });
};

export const useIssueTypeState = (jiraProject: JiraProjectData) => {
    const [lastUsedId, setLastUsedId] = useLocalStorage(`deqo/ui/jiraCreate/${jiraProject.id}/lastUsedIssueTypeId`, null as string);
    const defaultIssueType = (
        jiraProject.issueTypes.find(x => x.id === lastUsedId) ??
        jiraProject.issueTypes[0]
    );
    const [issueType, setIssueType] = useState(defaultIssueType);
    useEffect(() => setLastUsedId(issueType.id), [issueType]);
    return [issueType, setIssueType] as const;
};
